import { Component, OnInit, Input, Output, EventEmitter, ElementRef } from '@angular/core';
import { Broadcaster } from '../../service/Broadcaster';
import { GrandTotal } from 'app/components/class/budget/grand-total';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  @Output() scrollEvent = new EventEmitter<string>();
  @Output() mouseEvent = new EventEmitter<string>();
  data;
  newData;
  datas = [];
  total = {
    expenses: '',
    budget: '',
    coop: '',
    totalLessCoop: '',
    variance: '',
    actual: ''
  }
  actualTotals = {

  }
  open = false;
  openIcon;
  footer;
  windowHeight;
  viewActualBudget: boolean = false;
  rooftops;
  constructor(private broadcaster: Broadcaster, private elRef: ElementRef) {
  }

  ngOnInit() {
    
    this.broadcaster.on<any>('sendBudgetData').subscribe(data => {
      this.data = data.data;
      this.getData();
    });
    this.broadcaster.on<any>('updateGrandTotal').subscribe((data:GrandTotal) => {
      this.total.expenses = this.checkDecimal(data.targetBudget);
      this.rooftops.forEach((item,index) => {
        this.datas[index].expenses = this.checkDecimal(data.dealerShips[item.id])
      })
    });
    this.checkActualMode();
    this.broadcaster.on<any>('changeActualBudget').subscribe(data => {
      this.viewActualBudget = (this.viewActualBudget) ? false : true;

    });

    this.broadcaster.on<any>('sendNewBudgetData').subscribe(data => {
     
      this.data = data.data;
      this.getData();
    });
    this.broadcaster.on<any>('actualBudgetTotals').subscribe(data => {
     
      setTimeout(() => {
        this.total.actual = this.checkDecimal(data.actualTotal);
        for (let i in data.dealerTotals) {
          this.datas[i].actualTotal = this.checkDecimal(data.dealerTotals[i]);
        }
      }, 50)
    })
  }
  checkActualMode() {
    if (window.localStorage.getItem('actualMode') && window.localStorage.getItem('actualMode') === "actual")
    {
    
    /*  this.broadcaster.broadcast("changeActualBudget", {
        data: "changing actual budget"
      })*/
      this.viewActualBudget = true;
    } 

  }
  ngAfterViewInit() {
    this.openIcon = document.getElementById('open-icon');
    this.open = false;
    this.footer = document.getElementById('footer');
    this.windowHeight = window.innerHeight;
    this.footer.style.top = `${this.windowHeight - 70}px`;
    window.addEventListener('resize', () => {
      this.windowHeight = window.innerHeight;
      this.footer.style.top = `${this.windowHeight - 70}px`;
    });

  }
  getData() {
    this.datas = [];
    let expenses = 0, budget = 0, coop = 0, variance = 0;
    this.total.expenses = this.checkDecimal(this.data.grandTotal.targetBudget);
    this.total.budget = this.checkDecimal(this.data.budgetTarget.targetBudget);
    this.total.coop = this.checkDecimal(this.data.coop.targetBudget);
    this.total.variance = this.checkDecimal(this.data.variance.targetBudget);
    this.total.totalLessCoop = this.checkDecimal(this.data.totalLessCoop.targetBudget);
    this.rooftops = this.data.rooftops;
    for (let i in this.data.rooftops) {
      let rooftop = {
        expenses: this.checkDecimal(this.data.grandTotal.dealerShips[this.data.rooftops[i].id]),
        budget: this.checkDecimal(this.data.budgetTarget.dealerShips[this.data.rooftops[i].id]),
        coop: this.checkDecimal(this.data.coop.dealerShips[this.data.rooftops[i].id]),
        variance: this.checkDecimal(this.data.variance.dealerShips[this.data.rooftops[i].id]),
        totalLessCoop: this.checkDecimal(this.data.totalLessCoop.dealerShips[this.data.rooftops[i].id]),
        actualTotal: ''
      }
      this.datas.push(rooftop);
    }
  }
  checkDecimal(n) {
    if (n % 1 === 0) {
      return n.toLocaleString('en')
    }
    var c = 2,
      d = ".",
      t = ",",
      s = n < 0 ? "-" : "",
      i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
      j = (j = i.length) > 3 ? j % 3 : 0;
    return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - parseFloat(i)).toFixed(c).slice(2) : "");
  }
  openFooter() {
    let mainTable = document.getElementById('main-table');
    if (!this.open) {
      this.open = true;
      this.footer.classList.add('opened');
      this.footer.classList.remove('closed');
      this.openIcon.classList.add('iconClosed');
      mainTable.classList.add('footerOpen');
    } else {
      this.open = false;
      this.footer.classList.add('closed');
      this.footer.classList.remove('opened');
      this.openIcon.classList.remove('iconClosed');
      mainTable.classList.remove('footerOpen');
    }
  }
  scrolling(event:any) {
    this.scrollEvent.next();
  }
  mouseOver(event:any) {
    this.mouseEvent.next();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/budget/footer/footer.component.ts